import { useCookieConsentStore } from '@/stores/cookie-consent-store';

/** True when the visitor accepted marketing/analytics cookies (GA4, GTM, Meta, Hotjar, attribution). */
export function hasAnalyticsConsent(): boolean {
  return useCookieConsentStore.getState().status === 'accepted';
}
